import React from 'react';

const Loader = () => {
    return (
        <div className="loader-container">
            <div className="loader">Loading...</div>
        </div>
    );
};

export default Loader;
